module.exports = __webpack_public_path__ + "static/media/define.b5ba6dc2.svg";